import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { Button, TextField, Typography } from "@material-ui/core";
import "./Userform.css";
import { useNavigate, useParams } from "react-router-dom";
import { getFirestore, doc, getDoc, setDoc } from "firebase/firestore";
import { getUserLocation } from "./userLocation";
import {app, } from "../firebase";

function Preview() {
  const [formInfo, setFormInfo] = useState({
    formName: "",
    formDescription: "",
    questions: [],
  });

  const { id } = useParams();

  useEffect(() => {
    const cookie = Cookies.get("draftData");
    if (cookie) {
      const parsedCookie = JSON.parse(cookie);
      setFormInfo(parsedCookie);
    }
  }, []);

  useEffect(() => {
    const fetchFormData = async () => {
      try {
        const db = getFirestore(app);
        const formRef = doc(db, "forms", id);
        const docSnap = await getDoc(formRef);
        if (docSnap.exists()) {
          setFormInfo(docSnap.data());
        } else {
          console.log("No form found!");
        }
      } catch (error) {
        console.error("Error fetching form data:", error);
      }
    };

    if (id) {
      fetchFormData();
    }
  }, [id]);

  const navigate = useNavigate();
  const handleArrowBack = () => {
    const previousURL = sessionStorage.getItem("currentURL");
    navigate(previousURL);
  };

  const [formName, setFormName] = useState("");
  const [formDescription, setFormDescription] = useState("");
  const [percentage, setPercentage] = useState("");
  const [isAnonymous, setIsAnonymous] = useState(false);
  const [text, setText] = useState("");
  const [open, setOpen] = useState(false);
  const [color, setColor] = useState("success");
  const saveEmail = sessionStorage.getItem("email");
  const [enableTimer, setEnableTimer] = useState(false);
  const [timerDuration, setTimerDuration] = useState(0);
  
  // State for location
  const [location, setLocation] = useState(null);

  const [data, setData] = useState({
    formName: "",
    formDescription: "",
    questions: [],
    saveEmail,
    activate: true,
    percentage: "",
    timerDuration: "",
    location: null, // Add location field to the state
  });

  const [questions, setQuestions] = useState([
    {
      questionText: "",
      questionType: "radio",
      options: [
        { optionText: "" },
        { optionText: "" },
        { optionText: "" },
        { optionText: "" },
      ],
      answer: false,
      answerKey: "",
      points: 0,
      open: true,
      required: true,
    },
  ]);

  const handleSubmitForm = async () => {
    try {
      // Get the user's location
      const userLocation = await getUserLocation();
      
      // Construct the data object to save to Firebase
      const formData = {
        formName: data.formName || formName,
        formDescription: data.formDescription || formDescription,
        questions: data.questions.length ? data.questions : questions,
        saveEmail,
        isAnonymous,
        activate: true,
        percentage: data.percentage || percentage,
        enableTimer,
        timerDuration: data.timerDuration || timerDuration,
        location: userLocation, // Add the location to the form data**
        selectedInstructions: data.selectedInstructions || [],
        customInstructions: data.customInstructions || "",
      };
  
      console.log("Form Data before saving:", formData); // Debugging log
  
      if (Object.values(formData).some(value => value === undefined)) {
        console.error("One or more properties in formData is undefined");
        return;
      }
  
      // Get a reference to the Firestore database
      const db = getFirestore(app);
      const formRef = doc(db, "forms", id);
  
      // Save the form data with the unique ID as the document name
      await setDoc(formRef, formData, { merge: true });
      setColor("success");
      setOpen(true);
      setText("Form is submitted successfully");
  
      // Wait for a short time before navigating to the next page
      await new Promise((resolve) => setTimeout(resolve, 2000));
    } catch (error) {
      console.error("Error submitting form:", error);
      setColor("error");
      setText("Error submitting form. Please try again.");
      setOpen(true);
    }
  };

  return (
    <div className="submit">
      <div className="user_form">
        <div className="user_form_section">
          <div className="user_title_section">
            <Typography style={{ fontSize: "26px" }}>
              {formInfo.formName}
            </Typography>
            <Typography style={{ fontSize: "15px" }}>
              {formInfo.formDescription}
            </Typography>
          </div>
          {formInfo.questions.map((question, index) => (
            <div className="user_form_questions" key={index}>
              <Typography
                style={{
                  fontSize: "15px",
                  fontWeight: "400",
                  letterSpacing: ".1px",
                  lineHeight: "24px",
                  paddingBottom: "8px",
                }}
              >
                {index + 1}. {question.questionText}
              </Typography>

              {question.options.map((option, optionIndex) => (
                <div style={{ marginBottom: "5px" }} key={optionIndex}>
                  <div style={{ display: "flex" }}>
                    <div className="form-check">
                      {question.questionType !== "text" ? (
                        <label>
                          <input
                            type={question.questionType}
                            name={`option_${index}_${optionIndex}`}
                            value={option.optionText}
                            className="form-check-input"
                            required={question.required}
                            style={{
                              marginLeft: "5px",
                              marginRight: "5px",
                            }}
                          />
                          {option.optionText}
                        </label>
                      ) : (
                        <label>
                          <TextField
                            type={question.questionType}
                            name={`option_${index}_${optionIndex}`}
                            value={option.optionText}
                            className="form-check-input"
                            required={question.required}
                            style={{
                              marginLeft: "5px",
                              marginRight: "5px",
                            }}
                          />
                          {option.optionText}
                        </label>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ))}
          <div className="user_form_submit">
            <Button
              variant="contained"
              color="primary"
              style={{
                color: "white",
                backgroundColor: "#236AE7",
                marginLeft: "5px",
              }}
              onClick={handleSubmitForm}
            >
              Submit
            </Button>
            <Button
              variant="contained"
              onClick={handleArrowBack}
              color="primary"
              style={{
                color: "white",
                backgroundColor: "#236AE7",
                marginLeft: "5px",
              }}
            >
              Go Back
            </Button>
          </div>
          <div className="user_footer"> &#169; Digilytics Forms</div>
        </div>
      </div>
    </div>
  );
}

export default Preview;
